import React, { Component } from 'react'
import { observer } from 'mobx-react'
import StoreAutoComplete from './StoreAutoComplete'

import Users from '../../../stores/users'

@observer
export default class AutoCompleteUsers extends Component {
  constructor(...args) {
    super(...args)
    this.users = new Users()
    this.users.load()
  }

  renderSuggestion = (suggestion) => (
    <div>
      <strong>{suggestion.name}</strong>
      <br />
      <small>({suggestion.email})</small>
    </div>
  )

  render() {
    const { name, onSelect, selected, clearAfterSelect, exclude } = this.props
    return (
      <StoreAutoComplete
        store={this.users}
        getValue={this.getValue}
        renderSuggestion={this.renderSuggestion}
        name={name}
        exclude={exclude}
        selected={selected}
        onSelect={onSelect}
        placeholder="Select an Agent"
        clearAfterSelect={clearAfterSelect} />
    )
  }
}



// WEBPACK FOOTER //
// client/components/util/auto_complete/Users.js